'use client';

import styled from 'styled-components';
import Link from 'next/link';

import { Main } from 'components/Blocks';
import { Wave } from 'components/Elements/Animation';
import { H1, P } from 'components/Fonts/Font';

const AboutBox = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  color: #fff;
  flex-direction: column;
  padding: 10px;
  z-index: 100;

  p {
    font-size: 1.3rem;
    line-height: 1.7rem;
  }
  @media only screen and (min-width: 768px) {
    width: 600px;
    padding: 20px;
  }
`;

const AboutContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: space-evenly;
  margin: 40px 0 0 0;
  @media only screen and (min-width: 768px) {
    margin: auto;
  }
`;

export default function About() {
  return (
    <>
      <Wave />
      <Main bgColor="var(--darkGrey)" navColor="var(--white)">
        <AboutContainer>
          <AboutBox>
            <H1>About</H1>
            <P style={{ color: '#fff' }}>
              Tangible Tracks celebrates the art of collecting records and the sensory experience
              involved. However, it&apos;s not all music snobbery and smelling vinyl. It&apos;s the
              absurdity that revolves around the music industry.
            </P>

            <P style={{ color: '#fff' }}>
              <Link href="/indie-unheard">Indie Unheard</Link> explores the music and people behind
              the undiscoverable bands from around the globe. Often their stories are larger and
              more complicated than the music itself.
            </P>
          </AboutBox>
        </AboutContainer>
      </Main>
    </>
  );
}
